<div class="p-4">
    <h1 class="text-2xl font-bold">{{ branches.name }}</h1>
    <p>Manage your branches here.</p>
    <router-outlet></router-outlet>
</div>